import React, { ButtonHTMLAttributes, forwardRef } from "react";
import { VariantProps, cva } from "class-variance-authority";
import { cn } from "utils/Common";

const buttonVariants = cva(
  "items-center justify-center select-none gap-1 capitalize inline-flex text-base font-bold leading-5 w-fit fill-interactive-blue",
  {
    variants: {
      variant: {
        Primary: "bg-interactive-blue text-white ",
        Secondary:
          "border border-solid border-interactive-blue text-interactive-blue ",
        Tertiary: "text-interactive-blue",
        Danger: "bg-red text-white ",
      },
      size: {
        sm: "py-[6px] pl-3 pr-3",
        lg: "py-3 pl-6 pr-6",
        smFull: "py-[6px] pl-3 pr-3 w-full",
        lgFull: "py-3 pl-6 pr-6 w-full",
      },
      disabled: {
        true: "cursor-default fill-deep-blue-60",
      },
    },
    compoundVariants: [
      {
        disabled: true,
        variant: "Primary",
        className: "bg-gray-white cursor-not-allowed",
      },
      {
        disabled: false,
        variant: "Primary",
        className:
          "hover:bg-interactive-light-teal transition ease-in-out duration-100 active:bg-interactive-light-teal/90",
      },
      {
        disabled: true,
        variant: "Secondary",
        className: "border-gray-white text-gray-white cursor-not-allowed",
      },
      {
        disabled: false,
        variant: "Secondary",
        className:
          "hover:bg-interactive-light-blue transition ease-in-out duration-100 hover:border-interactive-light-teal hover:text-interactive-light-teal active:bg-white",
      },
      {
        disabled: true,
        variant: "Tertiary",
        className: "text-gray-white cursor-not-allowed",
      },
      {
        disabled: false,
        variant: "Tertiary",
        className:
          "hover:bg-interactive-light-blue transition ease-in-out duration-100 hover:text-interactive-light-teal active:bg-white",
      },
      {
        disabled: true,
        variant: "Danger",
        className: "bg-red cursor-not-allowed",
      },
      {
        disabled: false,
        variant: "Danger",
        className:
          "hover:bg-red transition ease-in-out duration-100 active:bg-red-800",
      },
    ],
    defaultVariants: {
      variant: "Primary",
      size: "sm",
    },
  },
);
interface ButtonProps
  extends
    Omit<ButtonHTMLAttributes<HTMLButtonElement>, "disabled">,
    VariantProps<typeof buttonVariants> {
  // children: ReactNode;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, size, variant, disabled, ...attributes }, ref) => {
    return (
      <button
        ref={ref}
        disabled={disabled!}
        className={cn(buttonVariants({ variant, size, disabled, className }))}
        {...attributes}
      />
    );
  },
);
export { Button, buttonVariants };
